import React from 'react'
import { Button, ControlLabel, FormControl, FormGroup } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import root from '../shared/utils'
import {updateBillingInfo} from '../api'

let imgSrc = root + '/common/latest/images/consumer/credit-card-icons/'
let formattedExp = false

const PaymentInfoModal = React.createClass({
  getInitialState: function () {
    return {
      name: '',
      billingAddress: '',
      zipcode: '',
      ccNumber: '',
      expDate: '',
      cvvCode: '',
      visa: imgSrc + 'Visa.png',
      mastercard: imgSrc + 'Mastercard.png',
      discover: imgSrc + 'Discover.png',
      amex: imgSrc + 'Amex.png'
      
    }
  },
  handleInputChange: function (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    
    if (name === 'expDate') {
      let matchingInts = value.match(/[0-9]*[/]?[0-9]*/)
      if (value.length <= 5) {
        if (value.length === 2 && formattedExp !== true) {
          this.setState({[name]: matchingInts[0] + '/'})
          formattedExp = true
        } else {
          this.setState({[name]: matchingInts[0]})
          formattedExp = false
        }
      }
    } 
    else if(name === 'ccNumber') {
      if(value.length <= 16) {
        let matchingInts = value.match(/([0-9]*)/)
        this.setState({[name]: matchingInts[0]})
      }
      
      // Card-brand prefix detection. Ranges mirror the canonical CardPatterns
      // (TW-18211) BIN definitions; matchers are prefix-only (no length/anchor)
      // so the icon lights progressively as the user types.
      if(value.match(/^4/)){
        //Visa (4)
        this.setState({visa: imgSrc + 'visa-lit.png' })
      }
      else if(value.match(/^5[1-5]/) || value.match(/^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d{2}|7(?:[01]\d|20))/)){
        //Mastercard (5-series BIN 51-55 or 2-series BIN 2221-2720)
        this.setState({mastercard: imgSrc + 'mastercard-lit.png' })
      }
      else if(value.match(/^3[47]/)){
        //Amex (34, 37)
        this.setState({amex: imgSrc + 'amex-lit.png' })
      }
      else if(value.match(/^(?:6011|65|64[4-9]|622(?:12[6-9]|1[3-9]\d|[2-8]\d{2}|9[01]\d|92[0-5]))/)){
        //Discover (6011, 65, 644-649, 622126-622925)
        this.setState({discover: imgSrc + 'discover-lit.png' })
      }
      else if(value.match(/^3(?:0[0-5]|[689])/)){
        //Diners Club (300-305, 36, 38, 39) - detection only; no icon asset yet
        this.resetCards()
      }
      else if(value.match(/^35/)){
        //JCB (35xx) - detection only; no icon asset yet
        this.resetCards()
      }
      else{
        this.resetCards();
      }
    }
    else if (name === 'cvvCode') {
      let matchingInts = value.match(/([0-9]*)/)
      if (matchingInts[0].length <= 4) {
        this.setState({[name]: matchingInts[0]})
      }
    } else {
      this.setState({[name]: value})
    }
  },
  resetCards: function(){
      this.setState({visa: imgSrc + 'Visa.png', amex: imgSrc + 'Amex.png', mastercard: imgSrc +'Mastercard.png', discover: imgSrc + 'Discover.png' })
  },
  componentDidMount: function () {
    if(this.props.loginData.customer.paymentProfile) { 
      let paymentInfo = this.props.loginData.customer.paymentProfile
      this.setState({billingAddress: paymentInfo.billingAddress, name: paymentInfo.billingName, zipcode: paymentInfo.billingZip})
    }
  },
  formatExpDate: function (type) {
    let splitDate = this.state.expDate.split('/')
    if (type === 'month') {
      return splitDate[0]
    } else {
      return '20' + splitDate[1]
    }
  },
  updateBillingInfo: function () {
    let profilePojo = {
      type: 'Anet',
      billingCardNumber: this.state.ccNumber,
      billingSecurityCode: this.state.cvvCode,
      billingExpMonth: this.formatExpDate('month'),
      billingExpYear: this.formatExpDate('year'),
      billingName: this.state.name,
      billingAddress: this.state.billingAddress,
      billingZip: this.state.zipcode
    }

    updateBillingInfo(profilePojo, this.props.loginData.customer.customerId).then((response) => {
      if (response === 'okay') {
        this.props.openNotificationModal('payment-info-modal', "Billing Info Updated!", "We have updated your billing information!")

      } 
      else {
        this.props.openNotificationModal('payment-info-modal', "Processing Error", "There was an error processing your changes. Please try again later.")
        this.closeModal()
        }
    })
  },
  closeModal: function () {
    if(this.props.loginData.customer.paymentProfile) { 
      let paymentInfo = this.props.loginData.customer.paymentProfile
      this.setState({billingAddress: paymentInfo.billingAddress, name: paymentInfo.billingName, zipcode: paymentInfo.billingZip, ccNumber: '', expDate: '', cvvCode: ''})
    }
    this.props.hide()
  },
  render: function () {
    return (
      <div >
        <Modal show={this.props.show} onHide={this.closeModal}>
          <div className='white-background'>
            <Modal.Header closeButton>
              <div className='center-block' style={{width: '90%', marginTop: 30}}>
                <h2 className='text-center'>Change Payment Info</h2>
                <br />
                <form>
                  <FormGroup bsClass='form-group' className={this.state.name ? 'has-value' : ''}>
                    <ControlLabel>Name of Card Holder</ControlLabel>
                    <FormControl value={this.state.name} type='text' name='name' onChange={this.handleInputChange} />
                  </FormGroup>
                  <FormGroup bsClass='form-group' className={this.state.billingAddress ? 'has-value' : ''}>
                    <ControlLabel>Billing Address</ControlLabel>
                    <FormControl value={this.state.billingAddress} type='text' name='billingAddress' onChange={this.handleInputChange} />
                  </FormGroup>
                  <div className='row'>
                    <div className='col-xs-6'>
                      <FormGroup bsClass='form-group' className={this.state.zipcode ? 'has-value' : ''} >
                        <ControlLabel>Zip Code</ControlLabel>
                        <FormControl value={this.state.zipcode} type='text' name='zipcode' onChange={this.handleInputChange} />
                      </FormGroup>
                    </div>
                  </div>
                  <div style={{backgroundColor: '#d6eac1', padding: 20, marginBottom: 30}}>
                    <FormGroup className={this.state.ccNumber ? 'has-value' : ''}>
                      <ControlLabel>Credit Card Number</ControlLabel>
                      <FormControl value={this.state.ccNumber} name='ccNumber' onChange={this.handleInputChange} />
                    </FormGroup>
                    <div className='row'>
                      <div className='col-xs-6'>
                        <FormGroup className={this.state.expDate ? 'has-value' : ''}>
                          <ControlLabel>Exp Date</ControlLabel>
                          <FormControl value={this.state.expDate} name='expDate' onChange={this.handleInputChange} />
                        </FormGroup>
                      </div>
                      <div className='col-xs-6'>
                        <FormGroup className={this.state.cvvCode ? 'has-value' : ''}>
                          <ControlLabel>CVV Code</ControlLabel>
                          <FormControl value={this.state.cvvCode} name='cvvCode' onChange={this.handleInputChange} />
                        </FormGroup>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xs-2' />
                      <div className='col-xs-8 text-center'>
                        <img src={this.state.visa} alt='visa icon' style={{padding: '0 8px 0 5px'}} />
                        <img src={this.state.mastercard} alt='mastercard icon' style={{padding: '0 5px 0 5px'}} />
                        <img src={this.state.discover} alt='discover icon' style={{padding: '0 5px 0 5px'}} />
                        <img src={this.state.amex} alt='amex icon' style={{padding: '0 5px 0 5px'}} />
                      </div>
                      <div className='col-xs-2' />
                    </div>
                    <div className='row'>
                      <div className='col-xs-1'>
                        <i className='fa fa-lock fa-lg' aria-hidden='true' style={{paddingLeft: '10px'}} />
                      </div>
                      <div className='col-xs-11'>
                        <span className='small'><small>Your account information is protected by industry certified 256-bit encryption and is protected against theft and fraud.</small></span>
                      </div>
                    </div>
                  </div>
                  <FormGroup>
                    <Button type='button' bsClass='btn btn-success btn-sm center-block' onClick={this.updateBillingInfo}>
                    Update Info
                  </Button>
                  </FormGroup>
                </form>
              </div>
            </Modal.Header>
          </div>
        </Modal>
      </div>
    )
  }
})

export default PaymentInfoModal



// WEBPACK FOOTER //
// ./src/components/modals/payment-info-modal.jsx